class n {
  constructor() {
    const e = document.createDocumentFragment();
    this.addEventListener = e.addEventListener.bind(e), this.removeEventListener = e.removeEventListener.bind(e), this.dispatchEvent = e.dispatchEvent.bind(e);
  }
  // EventTarget methods
  addEventListener;
  removeEventListener;
  dispatchEvent;
}
export {
  n as EventTargetFallback
};
